const $ = require('jquery');
require('inputmask');
const { noty_render_alert } = require('common/noty_notifications');

// Капча берёт колбэк при загрузке своего скрипта, раньше document.ready
window.passedCaptcha = () => window.submitCertificate(document.getElementsByName('smart-token')[0].value);

$(function () {
  const MIN_AMOUNT = 5000;

  let selectedDesign = 0;

  const imageCache = {};

  const designs = [0, 1, 2, 3, 4, 5];

  designs.forEach((design) => {
    const key = `${design}_${window.website_type}`;
    const img = new Image();

    img.src = `/certificates/preview?design=${design}`;
    img.onload = () => {
      imageCache[key] = img;
    };
  });

  setPreview(selectedDesign, $('#certificatePreview'));

  function setPreview(design, $img) {
    const key = `${design}_${window.website_type}`;
    const img = imageCache[key];

    if (img && img.complete) {
      $img.attr('src', img.src);
      showPreviewBtn();
    } else {
      const tempImg = new Image();
      tempImg.src = `/certificates/preview?design=${design}`;
      tempImg.onload = () => {
        imageCache[key] = tempImg;
        $img.attr('src', tempImg.src);
        showPreviewBtn();
      };
    }
  }

  function showPreviewBtn() {
    $('.certificate__preview_btn').css({
      opacity: 1,
      pointerEvents: 'auto',
    });
  }

  Inputmask('+7 (999) 999-99-99', { showMaskOnHover: false }).mask($('#receiver_phone'));
  Inputmask('+7 (999) 999-99-99', { showMaskOnHover: false }).mask($('#sender_phone'));

  $('input[name=where_send]').change(function () {
    const $receiverDataBlock = $('#receiverDataBlock');
    const isGift = $('#where_send-gift').prop('checked');

    if (isGift) {
      $receiverDataBlock.show();
    } else {
      $receiverDataBlock.hide();
      $receiverDataBlock.find('input:not([type=checkbox]), textarea').val('');
    }
  });

  $('#payment-btn').find('a').attr('href', $('.main-form-pay-method').eq(0).find('input').data('payment-link'));

  $('.main-form-pay-method').on('click', function () {
    $('#payment-btn').find('a').attr('href', $(this).find('input').data('payment-link'));
  });

  const $header = document.querySelector('.certificate_new__header');
  const $howItWorksWrapper = document.querySelector('.certificate__how_it_works_wrapper.mobile');

  if ($header && $howItWorksWrapper) {
    const observer = new ResizeObserver(() => {
      $howItWorksWrapper.style.marginTop = $header.offsetHeight + 'px';
    });
    observer.observe($header);
  }

  function toggleCustomAmountInput(show) {
    const $customAmountField = $('#custom_amount');

    if (show) {
      $customAmountField.closest('.mtui-text-field__wrapper').show();
    } else {
      $customAmountField.closest('.mtui-text-field__wrapper').hide();
    }
  }

  function handleCustomAmount() {
    const $input = $('#custom_amount');
    const $label = $('.certificate__amount_label');
    const $bonuses = $('.bonuses-block');

    let raw = $input.val().replace(/\D/g, '');

    if (!raw) {
      $input.val('');
      $bonuses.addClass('hidden');
      $label.show();
      return;
    }

    const amount = parseInt(raw, 10);

    $input.val(amount.toLocaleString('ru-RU'));

    if (amount >= MIN_AMOUNT) {
      updateBonuses(amount);
      $bonuses.removeClass('hidden');
      $label.hide();
    } else {
      $bonuses.addClass('hidden');
      $label.show();
    }
  }

  function applyAmount(value) {
    const isAnother = value === 'another';

    const $label = $('.certificate__amount_label');
    const $bonuses = $('.bonuses-block');

    toggleCustomAmountInput(isAnother);

    if (isAnother) {
      handleCustomAmount();
      return;
    }

    const amount = parseInt(value, 10);

    if (amount >= MIN_AMOUNT) {
      updateBonuses(amount);
      $bonuses.removeClass('hidden');
      $label.hide();
    } else {
      $bonuses.addClass('hidden');
      $label.show();
    }
  }

  function setDefaultAmount() {
    const initialAmount = $('input[name=amount]:checked').val();
    if (initialAmount) {
      applyAmount(initialAmount);
    }
  }

  setDefaultAmount();

  $('input[name=amount]').on('change', function () {
    applyAmount($(this).val());
  });

  $('#custom_amount').on('input', handleCustomAmount);

  $('.certificate__palette_container').on('click', function () {
    selectedDesign = $(this).find('.certificate__palette_item').data('design');

    $('.certificate__palette_container').removeClass('active');
    $(this).addClass('active');

    $('#certificate_design').val(selectedDesign);

    setPreview(selectedDesign, $('#certificatePreview'));
  });

  $('.open_popup').on('click', function () {
    setPreview(selectedDesign, $('#certificatePreviewFull'));
  });

  const $form = $('.form-inline');

  $form.on('submit', function (e) {
    e.preventDefault();

    if (!window.smartCaptcha) return;

    window.smartCaptcha.execute();
  });

  // Из bfcache виджет возвращается «пройденным», и execute() молчит
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) window.smartCaptcha?.reset();
  });

  window.submitCertificate = function (captchaToken) {
    clearErrors();

    const data = $form.serializeArray();
    data.push({ name: 'captcha_token', value: captchaToken });

    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      data: $.param(data),
      dataType: 'json',
      success: function (res) {
        if (res.redirect_url) {
          window.location.href = res.redirect_url;
        }
      },
      error: function (data) {
        // Токен одноразовый: следующей отправке нужна новая проверка
        window.smartCaptcha?.reset();

        const errors = data.responseJSON?.errors;
        if (!errors) {
          noty_render_alert('error', 'Не удалось оформить сертификат. Попробуйте ещё раз.');
          return;
        }

        Object.keys(errors).forEach(function (field) {
          const message = errors[field][0];

          if (field === 'amount') {
            addError($('#custom_amount'), message);
          } else if (field === 'time_to_send_at') {
            addDateTimeError(message);
          } else {
            addError($(`[name=${field}]`), message);
          }
        });

        scrollToError();
      },
    });
  };

  function addError($input, error) {
    let $wrapper = $input.closest('.mtui-text-field__wrapper');
    $wrapper.find('.mtui-text-field__error-label').show();
    $wrapper.addClass('mtui-text-field_error');
    if (error) {
      $wrapper.find('.mtui-text-field__error-label').text(error);
    } else {
      $wrapper.find('.mtui-text-field__error-label').text('Произошла ошибка');
    }
  }

  function clearErrors() {
    $('.mtui-text-field__wrapper')
      .removeClass('mtui-text-field_error')
      .removeClass('certificate__date_input-error')
      .find('.mtui-text-field__error-label')
      .hide()
      .text('');

    $('.certificate__datetime_error').hide().text('');
  }

  function addDateTimeError(error) {
    const $dateWrapper = $('#date').closest('.mtui-text-field__wrapper');
    const $timeWrapper = $('#time').closest('.mtui-text-field__wrapper');

    $dateWrapper.addClass('certificate__date_input-error');
    $timeWrapper.addClass('certificate__date_input-error');

    $('.certificate__datetime_error').text(error).show();
  }

  function scrollToError() {
    const $firstError = $('.mtui-text-field_error').first();

    if ($firstError.length) {
      $('html, body').animate(
        {
          scrollTop: $firstError.offset().top - 150,
        },
        300
      );

      $firstError.find('input, textarea, select').focus();
    }
  }
});

const BONUS_PERCENT = 0.05;

function calcBonuses(amount) {
  if (!amount || isNaN(amount)) return 0;
  return Math.round(amount * BONUS_PERCENT);
}

export function updateBonuses(amount) {
  const bonuses = calcBonuses(amount);
  $('#certificate-bonuses-count').text(`+ ${bonuses.toLocaleString('ru-RU')} бонусов`);
}
